<template>
  <v-row no-gutters class="pl-0 pr-2 py-2" style="position: relative;">
    <v-col class="shrink" v-if="page" style="margin-left: -10px;">
      <page-type-select :page="page" :large="true"></page-type-select>
    </v-col>
    <v-col>
      <content-editor
        ref="titleEditor"
        class="page-title pt-1"
        :disabled="!userCanEdit || disabled"
        v-model="pageTitle"
        :placeholder="titlePlaceholder"
        allowTraversal
        :emitText="true"
        :preventTab="true"
        @keyDownLastLine="traverse({ toRef: 'descriptionEditor', event: $event })"
        @keyEnter="traverse({ toRef: 'descriptionEditor', event: $event })"
        @keyShiftTab="$emit('tabBack')"
      ></content-editor>
    </v-col>
    <v-col class="shrink">
      <slot></slot>
    </v-col>
    <!-- <v-col cols="12" v-if="!hideDescription" class="py-2">
      <content-editor
        :disabled="!userCanEdit || disabled"
        ref="descriptionEditor"
        class=""
        v-model="pageNote"
        allowFormats
        :placeholder="descriptionPlaceholder || 'Add some notes or details...'"
        allowTraversal
        allowEnter
        :emitText="false"
        @keyUpFirstLine="traverse({ toRef: 'titleEditor', event: $event })"
        @keyDownLastLine="$emit('traverseOut', { direction: 'down', event: $event })"
        @keyShiftTab="$emit('tabBack')"
      ></content-editor>
    </v-col> -->
  </v-row>
</template>

<script>
import ContentEditor from '@/components/ContentEditor';
import PageTypeSelect from '@/components/ContextDoc/PageTypeIcon/PageTypeSelect';

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  props: [
    'title',
    'titlePlaceholder',
    'description',
    'descriptionPlaceholder',
    'disabled',
    'hideDescription',
    'page'
  ],
  components: { ContentEditor, PageTypeSelect },
  computed: {
    ...mapGetters('context', ['userCanEdit']),
    pageTitle: {
      get() {
        try {
          return { html: this.title };
        } catch (e) {
          console.error('could not find selected page item');
          return '';
        }
      },
      set(v) {
        //  Update page title
        this.$emit('updateTitle', v);
      }
    },
    pageNote: {
      get() {
        try {
          return { html: this.description };
        } catch (e) {
          console.error('could not find selected page description');
          return '';
        }
      },
      set(v) {
        this.$emit('updateDescription', v);
      }
    },
    contentEditor() {
      return this.$refs.editor;
    }
  },
  methods: {
    traverse({ toRef, dir = 'up', event }) {
      try {
        const targetRef = this.$refs[toRef];
        const bound = event && event.bounds ? event.bounds.left : 0;
        targetRef.setCaret({
          prevLeft: bound,
          direction: dir
        });
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style>
.page-title .ql-editor {
  font-size: 2em !important;
  font-weight: 300;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: Roboto, sans-serif !important;
}
</style>
